module.exports = __webpack_public_path__ + "static/img/enlarge-circular-4.febc0b5d.png";